<article class="demo-container">
  <h1>Demo Tenant</h1>
  <p>This is the demo page for a yet to be built tenant!</p>
  <p>Contact PlatePath to learn about our Inventory solution</p>
  <app-under-development></app-under-development>
</article>